import { createSlice } from '@reduxjs/toolkit';
import { appClient } from 'api/apiClient';
import { createAsyncThunkWrapper } from 'redux/thunk/createAsyncThunkWrapper';
import { normalizeParish, type Parish, type ParishPublic } from 'types/parishes';

interface ParishDetailsState {
    details: Parish | Record<string, never>;
    loading: boolean;
    error: string | null | boolean;
}

const initialState: ParishDetailsState = {
    details: {},
    loading: false,
    error: null,
};

interface FetchParishDetailsPayload {
    /** Parish UUID (route param historically named companyId). */
    parishId: string;
}

export const fetchParishDetails = createAsyncThunkWrapper<Parish, FetchParishDetailsPayload>(
    'parishDetails/fetchParishDetails',
    async ({ parishId }) => {
        const response: any = await appClient.get(`parishes/${parishId}`);
        // Browse-only: do not change selectedParishId (portal active parish).
        return normalizeParish(response as ParishPublic);
    }
);

const parishDetailsSlice = createSlice({
    name: 'parishDetails',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchParishDetails.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(fetchParishDetails.fulfilled, (state, action) => {
            state.loading = false;
            if (!action.payload) return;
            state.details = action.payload;
        });
        builder.addCase(fetchParishDetails.rejected, (state) => {
            state.loading = false;
            state.error = true;
        });
    },
});

export default parishDetailsSlice.reducer;
